import placeholdersChz from '@public/locales/es-chz-pa/placeholders.json';
import placeholdersNvy from '@public/locales/es-nvy-pa/placeholders.json';
import common from '@public/locales/es/common.json';
import dashboard from '@public/locales/es/dashboard.json';
import orderById from '@public/locales/es/orderById.json';
import orders from '@public/locales/es/orders.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * @file Configuración de i18next para la internacionalización.
 *
 * @description Este archivo inicializa i18next con los recursos de idioma y las configuraciones necesarias para la aplicación.
 */

i18n.use(initReactI18next).init({
  /**
   * @property {string} fallbackLng - El idioma de respaldo a utilizar si el idioma detectado no está disponible.
   */
  fallbackLng: 'es',
  /**
   * @property {string[]} ns - Los espacios de nombres a cargar.
   */
  ns: ['common', 'orderById', 'dashboard', 'orders', 'placeholders'],
  /**
   * @property {string} defaultNS - El espacio de nombres predeterminado a utilizar.
   */
  defaultNS: 'common',
  /**
   * @property {object} resources - Los recursos de idioma.
   */
  resources: {
    es: {
      common,
      orderById,
      dashboard,
      orders
    },
    'es-chz-pa': {
      placeholders: placeholdersChz
    },
    'es-nvy-pa': {
      placeholders: placeholdersNvy
    }
  },
  /**
   * @property {object} interpolation - Opciones de interpolación.
   *
   * @property {boolean} escapeValue - Si es verdadero, los valores se escapan para evitar ataques XSS. Se establece en falso porque React ya lo hace.
   */
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
